import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/shared/lib/auth';
import { canAccessOwnerCampaigns } from '@/shared/lib/navigation';
import { FullPageLoader } from '@/shared/components/full-page-loader';

/** Layout/guard de `/owner/campanhas*` — exige `user.hasCampaignAdvanced`. */
export function OwnerCampaignsGuard() {
  const { user, isLoading } = useAuth();

  if (isLoading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessOwnerCampaigns(user)) return <Navigate to="/owner" replace />;

  return <Outlet />;
}
